export const getModalPortal = (portalElementId?: string): HTMLElement | null => {
  if (typeof document === "undefined" || typeof window === "undefined") {
    return null;
  }

  const modalPortal = document.getElementById(portalElementId ? portalElementId : "portalContainer");

  return modalPortal;
};
